/**
 * The words for a tenant's key state (the `status` the portal keeps for
 * each tenant), one vocabulary for the tenant band, the Access key page, the
 * Customers list and the Portfolio map.
 */
export const KEY_WORDS: Record<string, [label: string, meaning: string]> = {
  connected: ["Connected", "The customer's key works."],
  expiring: ["Key expiring", "The customer's key ends soon. Ask for a longer one."],
  revoked: ["Key revoked", "The customer revoked or replaced the key."],
  unreachable: ["Not answering", "The tenant didn't answer at the last check."],
  waiting: ["Waiting for key", "No key from the customer yet."],
};

/** The key state's label; the stored value itself for one this list does not know. */
export const keyStateLabel = (status: string): string => KEY_WORDS[status]?.[0] ?? status;
